<template>
  <a
    ref="toggle"
    class="toggle"
    :class="{ active: active, disabled: disabled }"
    @click.prevent="toggle"
    :tabindex="disabled ? -1 : 0"
    v-on:keydown.space.prevent="toggle"
  >
    <div class="toggle-background">
      <div class="toggle-circle"></div>
    </div>
    <span class="toggle-title">{{ title }}</span>
  </a>
</template>
<script>
import Swipe from '../utils/Swipe';

export default {
  components: {},

  props: {
    /**
     * The title displayed next to the toggle.
     */
    title: {
      type: String,
    },

    /**
     * @model
     * The input value of the toggle.
     */
    modelValue: {
      type: Boolean,
    },

    /**
     * Boolean to enable / disable the input.
     */
    disabled: {
      type: Boolean,
    },
  },

  data() {
    return {
      active: this.modelValue,
    };
  },

  created() {
    this.swipe = new Swipe({
      threshold: 10,
      restraint: 20,
    });
    this.swipe.setOnLeft(() => this.swipeLeft());
    this.swipe.setOnRight(() => this.swipeRight());
  },

  mounted() {
    this.swipe.attachListeners(this.$refs.toggle);
  },

  beforeDestroy() {
    this.swipe.detachListeners(this.$refs.toggle);
  },

  methods: {
    toggle() {
      if (!this.disabled) {
        this.active = !this.active;
        /**
         * Event emitted when toggling value.
         * Updated with v-model
         * @property {Boolean} input The value of the input.
         */
        this.$emit('update:modelValue', this.active);
      }
    },

    swipeLeft() {
      if (!this.disabled) {
        this.active = false;
        this.$emit('update:modelValue', this.active);
      }
    },

    swipeRight() {
      if (!this.disabled) {
        this.active = true;
        this.$emit('update:modelValue', this.active);
      }
    },
  },

  computed: {},

  watch: {
    modelValue: {
      handler(value) {
        this.active = value;
      },
    },
  },
};
</script>
<style lang="postcss">
@import '@/pixel/style/variables';

.toggle {
  display: flex;
  align-items: center;
  user-select: none;
  transition: opacity 100ms ease-in-out;

  .toggle-title {
    cursor: pointer;
    transition: color 300ms ease-out;
    color: var(--link-color);
  }

  .toggle-background {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    position: relative;
    width: 40px;
    height: 24px;
    background-color: var(--grey-light);
    border-radius: var(--button-border-radius);
    border: 1px solid var(--grey-light);
    margin-right: 8px;
    transition: background-color 300ms ease-out, border-color 300ms ease-out;
  }

  .toggle-circle {
    position: absolute;
    right: 17px;
    background-color: var(--white);
    border-radius: var(--circle-border-radius);
    border: 1px solid var(--transparent);
    height: 18px;
    width: 18px;
    transition: right 300ms ease-out;
  }

  &.active {
    .toggle-background {
      background-color: var(--accent-color);
      border: 1px solid var(--accent-color);
    }

    .toggle-circle {
      right: 1px;
    }

    .toggle-title {
      color: var(--accent-color);
    }
  }

  &[data-focus-visible-added] {
    .toggle-background {
      border-color: var(--grey-medium);
      box-shadow: 0px 0px 0px 1px var(--grey-medium);
    }
  }

  &.disabled {
    opacity: 0.3;
    cursor: default;

    .toggle-title {
      cursor: default;
    }
  }
}
</style>
